import { StrictMode, createElement } from "react";
import { createRoot, type Root } from "react-dom/client";

import { WidgetShell } from "../widget/WidgetShell";

export interface TecmojoWidgetConfig {
  apiBaseUrl: string;
  mountSelector?: string;
  title?: string;
}

export function mountTecmojoWidget(config: TecmojoWidgetConfig) {
  const selector = config.mountSelector ?? "#tecmojo-chatbot-widget";
  let host = document.querySelector(selector);
  if (!(host instanceof HTMLElement)) {
    host = document.createElement("div");
    if (selector.startsWith("#")) {
      host.id = selector.slice(1);
    }
    document.body.appendChild(host);
  }

  const root: Root = createRoot(host);
  root.render(
    createElement(
      StrictMode,
      null,
      createElement(WidgetShell, {
        apiBaseUrl: config.apiBaseUrl,
        embedded: true,
        title: config.title,
      }),
    ),
  );

  return {
    destroy() {
      root.unmount();
    },
  };
}
